var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-to-clipboard-wrapper",on:{"click":_vm.copyContent}},[_c('i',{staticClass:"far fa-clone"}),(_vm.showTooltip)?_c('span',{staticClass:"tooltip-text",class:{ 'tooltip-success': _vm.isSuccess, 'tooltip-error': !_vm.isSuccess }},[_vm._v(" "+_vm._s(_vm.tooltipMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }